import React, { useEffect, useRef } from "react";
import "../../style/components/IngredientList.css";
import { motion } from "framer-motion";
import IngredientCollapse from "./IngredientCollapse";

function IngredientListPC({
  size,
  ingredientPreview,
  showIngredient,
  language,
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (ingredientPreview?.length === 1) {
      showIngredient(ingredientPreview[0]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ingredientPreview]);

  useEffect(() => {
    setTimeout(() => {
      ref?.current?.scrollIntoView({ behavior: "smooth" });
    }, 500);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "easeInOut", duration: 0.2 }}
    >
      <div ref={ref} className="ingredient-collapse-container">
        <div>
          {ingredientPreview.map((ingredient) => (
            <IngredientCollapse
              key={ingredient.id}
              ingredient={ingredient}
              onIngredientClick={() => showIngredient(ingredient)}
              language={language}
              collapsedSize={size}
              ingredientPreview={ingredientPreview}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
}

export default IngredientListPC;
